import { IS_PROD } from "./constants"

const showFlag = !IS_PROD

export const Flags = {
  General: {
    Example: showFlag,
    Theming: false,
    DarkMode: true,
    BatteryGroundLease: true,
    // Sending developer Change Orders and Scopes of Work for e-signature. On in
    // dev and staging, off in production: a real send emails a real developer a
    // real contract, so production waits until the flow has been exercised on
    // staging against DocuSign demo.
    DocumentSigning: showFlag,
  },
} as const

export type FlagsType = typeof Flags
